<template>
<div class="page">
    <div id="container"></div>
	<div id="panel"></div>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";

import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {

    data() {
        return {
            address: this.$route.query.address
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    naviTitle: "地图"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
        }
        // console.log(this.$refs.marker)
    },
    mounted: function () {
        this.renderMap() // 渲染地图
    },
    methods: {
        renderMap() {
            var that = this
            var map = new AMap.Map("container", {
                resizeEnable: true
            });
            AMap.service(["AMap.PlaceSearch"], function () {
                //构造地点查询类
                var placeSearch = new AMap.PlaceSearch({
                    pageSize: 5, // 单页显示结果条数
                    pageIndex: 1, // 页码
                    city: "北京", // 兴趣点城市 默认北京
                    citylimit: true, //是否强制限制在设置的城市内搜索
                    map: map, // 展现结果的地图实例
                    panel: "panel", // 结果列表将在此容器中进行展示
                    autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
                });
                //关键字查询
				placeSearch.search(that.address);
				// placeSearch.search('衡水老白干');
            });
        }
    }

};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
#container {
    width: 10rem;
    height: 100vh;
}
 #panel {
	position: absolute;
	background-color: white;
	max-height: 90%;
	overflow-y: auto;
	top: 0rem;
	right: 0rem;
	width: 8rem;
}
</style>
